<script>
import api from '@utils/api'
import { sortBy } from 'lodash'

export default {
  name: 'EditMergeSpecification',
  props: {
    editSpecification: {
      type: Boolean,
      default: false,
    },
    specification: {
      type: Object,
      default: () => {},
    },
    currentDocument: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      document: this.$route.params.document,
      item: {
        id: this.specification.id,
        document: this.specification.document,
        goods: this.specification.goods,
        serial: this.specification.serial,
        unit: this.specification.unit,
        quantity: this.specification.quantity,
      },
      rules: {
        goods: [x => !!x || this.$t('validation__is_required')],
        serial: [x => !!x || this.$t('validation__is_required')],
      },
      serialNumbers: [],
      serialNumbersLoading: false,
    }
  },
  computed: {
    isSelectedSerial() {
      return (
        this.document.type === 2 ||
        this.document.type === 4 ||
        this.document.type === 5
      )
    },
    goods() {
      return this.$store.getters['data/getGoods'](this.document.type)
    },
    isFinalized() {
      return this.$route.params.document.status === 2
    },
    currentGoods() {
      return this.item.goods
    },
  },
  watch: {
    specification: {
      handler(val) {
        Object.assign(this.item, val)
        this.getSerials()
      },
      deep: true,
    },
    currentGoods(value) {
      if (!value) this.serialNumbers = []
      else {
        this.getSerials()
      }
    },
  },
  methods: {
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    submit() {
      if (this.$refs.editSpecificationForm.validate()) {
        this.loading = true
        api.updateSpecification(this.item).then(resoponse => {
          this.$emit('spec-updated')
          this.loading = false
        })
      }
    },
    getSerials() {
      this.serialNumbers.push(this.item.serial)
      this.serialNumbersLoading = true
      api
        .getSerialNumbers(this.currentDocument.fromWarehouse, '2,5')
        .then(response => {
          this.serialNumbers = this.serialNumbers.concat(response)
          api
            .getSerialNumbers(this.currentDocument.fromWarehouse, 3)
            .then(response => {
              this.serialNumbers = sortBy(this.serialNumbers.concat(response))
              this.serialNumbersLoading = false
            })
        })
    },
  },
}
</script>

<template>
  <v-dialog
    :value="editSpecification"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__update_specification') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-form
                ref="editSpecificationForm"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                  :label="$t('label__document')"
                  :value="document.number"
                  name="document"
                  readonly
                />
                <v-select
                  :items="goods"
                  :label="$t('label__article')"
                  v-model="item.goods"
                  :rules="rules.goods"
                  :readonly="isFinalized"
                  item-text="shortName"
                  item-value="id"
                  required
                  autocomplete
                />
                <v-select
                  :items="serialNumbers"
                  :label="$t('label__serial')"
                  v-model="item.serial"
                  :rules="rules.serial"
                  :readonly="isFinalized"
                  :disabled="!serialNumbers.length"
                  :loading="serialNumbersLoading"
                  required
                  autocomplete
                />
                <v-text-field
                  :label="$t('label__unit')"
                  :value="getValue('unit', item.unit)"
                  name="unit"
                  readonly
                />
                <v-text-field
                  :label="$t('label__quantity')"
                  :value="item.quantity"
                  name="quantity"
                  readonly
                />
              </v-form>
              <small>* {{ $t('label__requier_small_text') }}</small>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="$emit('close-modal')">{{ isFinalized ? $t('buttons__close') : $t('buttons__cancel') }}</v-btn>
        <v-btn
          v-if="!isFinalized"
          :disabled="loading"
          :loading="loading"
          color="success"
          @click="submit">{{ $t('buttons__update') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
.warningMsg {
  color: #ff5252;
}
</style>
